import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const before = ['Uren besteden aan het voorbereiden van elke training', 'Op internet zoeken naar oefeningen die niet aansluiten', 'Geen duidelijke opbouw van jaar tot jaar', 'Onzeker over hoe je techniek en tactiek moet uitleggen', 'Geen kant-en-klare evaluaties of antwoordsleutels'];
const after = ['Een heel seizoen uitgestippeld voor elk niveau', 'Printklare trainingen, oefeningen en werkbladen', 'Een duidelijke doorlopende leerlijn van 6 tot 16 jaar', 'Simpel stap-voor-stap trainen, ook zonder hockeyachtergrond', 'Ingebouwde evaluaties, projecten en antwoordsleutels'];
const highlights: [string, string][] = [['500+', "PAGINA'S LESMATERIAAL"], ['6–16', 'LEEFTIJDEN GEDEKT'], ['100%', 'VELDKLAAR']];
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-165" data-mp="206v25f8egipl">
      <Reveal className="mx-auto max-w-5xl" data-id="element-166" data-mp="209hj25h6kakh">
        <div className="mx-auto max-w-3xl text-center" data-id="element-167" data-mp="fasrdd41jc5b">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-moss" data-id="element-168" data-mp="f99b3midx13j">
            EEN BETERE MANIER OM HOCKEY TE TRAINEN
          </p>
          <h2 className="text-4xl font-black leading-[1.08] tracking-tight text-brand-green md:text-5xl" data-id="element-169" data-mp="5dxt8vbojdrk">
            Van een Onzekere Trainer tot een{' '}
            <span className="italic text-brand-goldink" data-id="element-170" data-mp="y1k8x1y6m8us">
              Zelfverzekerde Hockeycoach.
            </span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-171" data-mp="130wxbr4pbnzh">
            Hockey Ready verandert uren aan voorbereiding in één open-en-train
            systeem. Kom bij elke training aan met een duidelijk plan, zinvolle
            oefeningen en het zelfvertrouwen om echt impact te maken.
          </p>
        </div>

        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-172" data-mp="39th4y0tyg4vc">
          {highlights.map(([value, label]) => <div key={label} className="px-5 py-5 text-center" data-id="element-173" data-mp="1fbxmczuts7zw">
              <strong className="block font-serif text-3xl leading-none text-brand-orange" data-id="element-174" data-mp="1ajwctlp1kvdk">
                {value}
              </strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.08em] text-brand-gray" data-id="element-175" data-mp="15kbdha5yml0b">
                {label}
              </span>
            </div>)}
        </div>

        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_18px_45px_rgba(31,92,63,0.10)]" data-id="element-176" data-mp="witot3ehlb00">
          <div className="grid md:grid-cols-2" data-id="element-177" data-mp="rn4x1m8pkye9">
            <Comparison title="VOOR" items={before} positive={false} data-id="element-178" data-mp="mna65ioxo8t7" />
            <Comparison title="MET HOCKEY READY" items={after} positive data-id="element-179" data-mp="2lz2vct5hc9vd" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-180" data-mp="2h08dbtfc6pcb">
            Een complete hockeymethode die je helpt minder voor te bereiden en
            met meer zelfvertrouwen te trainen.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-[#F1EEE6]'}`} data-id="element-181" data-mp="26io1oix63rau">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-182" data-mp="2akriln2lvo3i">
        <div data-id="element-183" data-mp="2fijfkvi3y0ek">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-moss' : 'text-brand-gray'}`} data-id="element-184" data-mp="2fi1bxdt48jwm">
            {positive ? 'HET KANT-EN-KLARE TRAININGSSYSTEEM' : 'DE PRIJS VAN HELEMAAL OPNIEUW BEGINNEN'}
          </p>
          <h3 className="mt-2 font-serif text-2xl font-bold tracking-tight text-brand-green" data-id="element-185" data-mp="3vw9ocfk69cuj">
            {title}
          </h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-moss text-white shadow-md' : 'bg-brand-alt text-brand-gray'}`} data-id="element-186" data-mp="18qzive9qfd86">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-187" data-mp="1hngv6ktu1h5i" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-188" data-mp="1cox98kf8o5d5">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-189" data-mp="1rmy0v2933v1h">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-moss' : 'text-brand-gray'}`} aria-hidden="true" data-id="element-190" data-mp="20g1jrq2i103i" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-191" data-mp="1wezh0z9di5ws">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}